module.exports = __webpack_public_path__ + "static/media/testRide.0815b8e6.svg";